/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceByDeviceTypeResponse
 */
export interface DeviceByDeviceTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceByDeviceTypeResponse
     */
    macAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceByDeviceTypeResponse
     */
    serialNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof DeviceByDeviceTypeResponse
     */
    lastConnectionDate?: Date;
}

export function DeviceByDeviceTypeResponseFromJSON(json: any): DeviceByDeviceTypeResponse {
    return DeviceByDeviceTypeResponseFromJSONTyped(json, false);
}

export function DeviceByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'macAddress': !exists(json, 'macAddress') ? undefined : json['macAddress'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'lastConnectionDate': !exists(json, 'lastConnectionDate') ? undefined : (new Date(json['lastConnectionDate'])),
    };
}

export function DeviceByDeviceTypeResponseToJSON(value?: DeviceByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'macAddress': value.macAddress,
        'serialNumber': value.serialNumber,
        'lastConnectionDate': value.lastConnectionDate === undefined ? undefined : (value.lastConnectionDate.toISOString()),
    };
}

